// The browser's own random device number (DESIGN-security.md, step 1).
//
// Sent with every request as `X-HH-Device` so the server can tell "Carl's laptop again" from
// "a device Carl has never used" — the "New device" label and, in step 2, the "Was this you?"
// email — WITHOUT fingerprinting anybody: it's a random number this browser made up, kept in
// its own storage, and the server only ever keeps a hash of it. Clearing the browser's data
// makes a new one, which is honest: to us it is a new device.
const KEY = 'hh_device';

function makeOne() {
  try {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
  } catch { /* fall through */ }
  return `d-${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}${Math.random().toString(36).slice(2)}`;
}

export function deviceId() {
  try {
    let id = window.localStorage.getItem(KEY);
    if (!id) {
      id = makeOne();
      window.localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    return null;   // storage blocked: no number, the server simply can't spot new devices
  }
}
